<template>
    <div data-component="Badge"
         class="label label-info">
        <slot></slot>
    </div>
</template>
